import { takeEvery } from 'redux-saga/effects'
import { gCall } from './utils'
import * as action from '../actions'
import api from '../middleware/api'

function* watchForBuyPrize() {
  yield takeEvery(action.BUY_PRIZE,
    gCall(api.buyPrize, action.buyPrizeSucceeded, action.buyPrizeFailed),
  )
}

function* watchForFetchOwnPrize() {
  yield takeEvery(action.LOAD_OWN_PRIZES,
    gCall(api.fetchOwnPrizes, action.ownPrizesFetchSucceeded, action.ownPrizesFetchFailed),
  )
}

function* watchForFetchPrizes() {
  yield takeEvery(action.PRIZES_FETCH,
    gCall(api.fetchPrizes, action.prizesFetchSucceeded, action.prizesFetchFailed),
  )
}

export default [watchForFetchOwnPrize, watchForBuyPrize, watchForFetchPrizes]



// WEBPACK FOOTER //
// ./src/sagas/prizes.jsx